<script setup lang="ts">
import type { Icon } from '@/types/types'
import CardTitle from '../CardTitle.vue'

defineProps<{
  sectionMainTitle?: string
  sectionMainSubtitle?: string
  sectionMainIcon?: Icon
}>()
</script>

<template>
  <section class="rounded-md border bg-white">
    <div
      v-if="sectionMainTitle"
      class="flex flex-col items-start gap-3 p-2 sm:border-b sm:border-border md:p-5 xl:flex-row xl:items-center xl:justify-between xl:gap-4"
    >
      <CardTitle
        class="min-w-0"
        :display-subtitle-on-mobile="false"
        :name="sectionMainIcon"
        :subtitle="sectionMainSubtitle"
        :title="sectionMainTitle"
      />
      <slot name="headerAction" />
    </div>
    <div class="p-2 sm:border-b sm:border-border md:p-5">
      <slot name="content" />
    </div>
  </section>
</template>
